import axios from 'axios';
import authService from './authService';

const API_URL = '/api/';

class FileManagerService {
  async getFolders() {
    const res = await axios.get(API_URL + 'file-folders/', { headers: authService.authHeader() });
    return res.data;
  }

  async createFolder(data) {
    const res = await axios.post(API_URL + 'file-folders/', data, { headers: authService.authHeader() });
    return res.data;
  }

  async updateFolder(id, data) {
    const res = await axios.patch(API_URL + `file-folders/${id}/`, data, { headers: authService.authHeader() });
    return res.data;
  }

  async deleteFolder(id) {
    await axios.delete(API_URL + `file-folders/${id}/`, { headers: authService.authHeader() });
  }

  async reorderFolders(items) {
    const res = await axios.post(API_URL + 'file-folders/reorder/', items, { headers: authService.authHeader() });
    return res.data;
  }

  async getStorageUsage() {
    const res = await axios.get(API_URL + 'file-folders/storage-usage/', { headers: authService.authHeader() });
    return res.data;
  }

  async uploadFile(folderId, file, onUploadProgress) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folderId);
    formData.append('name', file.name);
    const res = await axios.post(API_URL + 'union-files/', formData, {
      headers: { ...authService.authHeader(), 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    });
    return res.data;
  }

  async renameFile(id, name) {
    const res = await axios.patch(API_URL + `union-files/${id}/`, { name }, { headers: authService.authHeader() });
    return res.data;
  }

  async deleteFile(id) {
    await axios.delete(API_URL + `union-files/${id}/`, { headers: authService.authHeader() });
  }

  async moveFile(id, folderId) {
    const res = await axios.patch(API_URL + `union-files/${id}/move/`, { folder: folderId }, { headers: authService.authHeader() });
    return res.data;
  }
}

const fileManagerService = new FileManagerService();
export default fileManagerService;
